<section class="section banner">
    <div [@bannerTrigger] class="container">
        <div class="section-box-banner">
            <div class="content">
                <div>
                    <h1>{{ pretitle }}</h1>
                </div>
                <div class='banner-title'>
                    <h2>PAVAN MEKALA.</h2>
                    <h3>MEAN / MERN Stack Developer</h3>
                </div>
                <div class='banner-description'>
                    <p [innerHTML]="bannerDescription" class="mt-4"></p>
                </div>
            </div>
            <div class="div-btn-banner">
                <a href="mailto:pavanmekala0129@gmail.com" target="_black" class="main-btn">
                    {{ actionBtn }}
                </a>
            </div>
        </div>
    </div>
</section>